// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LI1g","comment":"styles_comment__29NOa"};